import React, { useMemo } from 'react';
import { Chips } from '@gerdau/hefesto-mais-web';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { EVehicleTypes } from '../../../../../store/ducks/fabrication-contracts/types';
import { EProductType } from '../../../../../store/ducks/fabrication-purchase-order/types';
import { VehicleTypeContainer } from './styles';

interface IVehicleTypeProps {
  vehiclesTypes: EVehicleTypes[];
  onSelectVehicleType: (newValue: EVehicleTypes[]) => void;
  productType: EProductType;
}

const VehicleType: React.FC<IVehicleTypeProps> = ({
  vehiclesTypes,
  onSelectVehicleType,
  productType
}) => {
  const chipsOptions = useMemo(
    () =>
      Object.values(EVehicleTypes).map((type) => {
        return { id: type, label: type };
      }),
    [EVehicleTypes]
  );

  return (
    <VehicleTypeContainer>
      <span>Selecione os veículos que essa obra pode receber</span>
      <Chips
        chips={chipsOptions}
        type="filter"
        disabled={productType === EProductType.ESTACA_ARMADA}
        handleSelect={(checkedValue: CheckboxValueType[]) =>
          onSelectVehicleType(checkedValue as EVehicleTypes[])
        }
        selectedChipIds={vehiclesTypes}
      />
    </VehicleTypeContainer>
  );
};

export default VehicleType;
